var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Popup',_vm._b({attrs:{"type":"Card","title":_vm.title,"maxWidth":800},on:{"opened":_vm.opened,"closed":_vm.closed},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("activator",null,null,{ on: on, attrs: attrs })]}},{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true),model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},'Popup',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }